<template>
  <div class="left-menu-content">
    <Menu width="180px" ref="menu"
      :open-names="openMenu"
      :active-name="activeName"
      accordion
      @on-open-change="openCloseMenu"
      @on-select="jumpMenu">
      <!--运营报告-->
      <template v-if="$route.meta.factory === 'report'">
        <!-- 统计结算 -->
        <Submenu name="tongsettle" v-if="roles.includes('统计结算')">
          <template slot="title">
            <i class="yjh-icon iconfont icontongjijiesuan"></i>统计结算
          </template>
          <MenuItem name="settlemonth" v-if="roles.includes('月账单')">月账单</MenuItem>
          <MenuItem name="settlehistory" v-if="roles.includes('交易记录')">交易记录</MenuItem>
        </Submenu>
      </template>
      <!-- 控制台 -->
      <template v-else-if="$route.meta.factory !== 'standLib'">
        <!-- 代理工业服务商列表 -->
        <Submenu name="agentuser" v-if="roles.includes('用户管理')">
          <template slot="title">
            <i class="yjh-icon iconfont iconyonghuguanli"></i>用户管理
          </template>
          <MenuItem name="agentind" v-if="roles.includes('工业列表')">工业列表</MenuItem>
          <MenuItem name="agentser" v-if="roles.includes('服务商列表')">服务商列表</MenuItem>
        </Submenu>
        <!-- 兑换卡 -->
        <Submenu name="exchangecard" v-if="roles.includes('兑换卡')">
          <template slot="title">
            <i class="yjh-icon iconfont iconduihuanka"></i>兑换卡
          </template>
          <MenuItem name="cardlist" v-if="roles.includes('礼包兑换')">礼包兑换</MenuItem>
          <MenuItem name="toollist" v-if="roles.includes('工具兑换')">工具兑换</MenuItem>
        </Submenu>
        <Submenu name="channel" v-if="roles.includes('渠道管理')">
          <template slot="title">
            <i class="yjh-icon iconfont iconqudaoguanli"></i>渠道管理
          </template>
          <MenuItem name="channelList" v-if="roles.includes('渠道列表')">渠道列表</MenuItem>
        </Submenu>
        <!-- 交易管理 -->
        <Submenu name="trade" v-if="roles.includes('交易管理')">
          <template slot="title">
            <i class="yjh-icon iconfont iconjiaoyiguanli"></i>交易管理
          </template>
          <MenuItem name="aliPayment" v-if="roles.includes('会员支付宝流水查询')">会员支付宝流水查询</MenuItem>
          <MenuItem name="vipPayment" v-if="roles.includes('会员转账交易审核')">会员转账交易审核<span class="menu-badge"
            v-if="vipCount !== 0"
            :style="{lineHeight: vipCount !== '...' ? '14px' : '7px'}"
          >{{vipCount}}</span></MenuItem>
          <MenuItem name="ukeyPayment" v-if="roles.includes('UKEY付款流水查询')">UKey付款流水查询</MenuItem>
          <MenuItem name="tranService" v-if="roles.includes('交易服务费流水查询')">交易服务费流水查询</MenuItem>
          <MenuItem name="recharge" v-if="roles.includes('充值流水查询')">充值流水查询</MenuItem>
          <MenuItem name="withdrawal" v-if="roles.includes('提现流水查询')">提现流水查询</MenuItem>
          <MenuItem name="payment" v-if="roles.includes('付款流水查询') && roles.includes('/trade/payment')">付款流水查询</MenuItem>
          <MenuItem name="receivable" v-if="roles.includes('收款流水查询') && roles.includes('/trade/receivable')">收款流水查询</MenuItem>
          <MenuItem name="sameTradeDetail" v-if="roles.includes('账户互转流水查询')">账户互转流水查询</MenuItem>
          <!-- <MenuItem name="reportSearch" v-if="roles.includes('调研报告流水查询')">调研报告流水查询</MenuItem> -->
        </Submenu>
        <!-- 北京发票 -->
        <Submenu name="invoiceBeijing" v-if="roles.includes('北京发票')">
          <template slot="title">
            <i class="yjh-icon iconfont iconbeijingfapiao"></i>北京发票
          </template>
          <MenuItem name="invoiceApplyBj" v-if="roles.includes('开票申请') && roles.includes('/invoiceBeijing/invoiceApply')">开票申请（{{invoiceBj}}）</MenuItem>
          <MenuItem name="invoiceRecordBj" v-if="roles.includes('开票记录') && roles.includes('/invoiceBeijing/invoiceRecord')">开票记录</MenuItem>
          <MenuItem name="invoiceDiscardBj" v-if="roles.includes('作废记录') && roles.includes('/invoiceBeijing/invoiceDiscard')">作废记录</MenuItem>
        </Submenu>
        <!-- 贵阳发票 -->
        <Submenu name="invoiceGuiyang" v-if="roles.includes('贵阳发票')">
          <template slot="title">
            <i class="yjh-icon iconfont iconguiyangfapiao"></i>贵阳发票
          </template>
          <MenuItem name="invoiceApplyGy" v-if="roles.includes('开票申请') && roles.includes('/invoiceGuiyang/invoiceApply')">开票申请（{{invoiceGy}}）</MenuItem>
          <MenuItem name="invoiceRecordGy" v-if="roles.includes('开票记录') && roles.includes('/invoiceGuiyang/invoiceRecord')">开票记录</MenuItem>
          <MenuItem name="invoiceDiscardGy" v-if="roles.includes('作废记录') && roles.includes('/invoiceGuiyang/invoiceDiscard')">作废记录</MenuItem>
        </Submenu>
        <!-- 对账中心 -->
        <Submenu name="duizhang" v-if="roles.includes('对账中心')">
          <template slot="title">
            <i class="yjh-icon iconfont iconduizhangzhongxin"></i>对账中心
          </template>
          <MenuItem name="receivableAccount" v-if="roles.includes('收款流水查询') && roles.includes('/duizhang/receivableAccount')">收款流水查询</MenuItem>
        </Submenu>
        <Submenu name="settle" v-if="roles.includes('结算管理')">
          <template slot="title">
            <i class="yjh-icon iconfont iconjiesuanguanli"></i>结算管理
          </template>
          <MenuItem name="accounts" v-if="roles.includes('平台账户查询')">平台账户查询</MenuItem>
          <MenuItem name="cards" v-if="roles.includes('已绑定银行卡信息')">已绑定银行卡信息</MenuItem>
          <MenuItem name="fundCount" v-if="roles.includes('资金总收付统计')">资金总收付统计</MenuItem>
        </Submenu>
        <Submenu name="flow" v-if="roles.includes('流量管理')">
          <template slot="title">
            <i class="yjh-icon iconfont iconjiesuanguanli"></i>流量管理
          </template>
          <MenuItem name="live" v-if="roles.includes('直播数流水查询')">直播数流水查询</MenuItem>
          <MenuItem name="meeting" v-if="roles.includes('会议室流水查询')">会议室流水查询</MenuItem>
          <MenuItem name="diaoyan" v-if="roles.includes('调研流水查询')">调研流水查询</MenuItem>
          <MenuItem name="reportSearch" v-if="roles.includes('调研报告流水查询')">调研报告流水查询</MenuItem>
        </Submenu>
        <Submenu name="invoice" v-if="roles.includes('发票信息')">
          <template slot="title">
            <i class="yjh-icon iconfont iconfapiaoguanli"></i>发票信息
          </template>
          <MenuItem name="vipInvoice" v-if="roles.includes('历史开具发票')">历史开具发票</MenuItem>
          <MenuItem name="examinei" v-if="roles.includes('发票信息审核(工业)')">发票信息审核(工业)</MenuItem>
          <MenuItem name="examines" v-if="roles.includes('发票信息审核(服务商)')">发票信息审核(服务商)</MenuItem>
        </Submenu>
        <Submenu name="member" v-if="roles.includes('会员管理')">
          <template slot="title">
            <i class="yjh-icon icon-member"></i>会员管理
          </template>
          <MenuItem name="memberBill" v-if="roles.includes('会员流水查询')">会员流水查询</MenuItem>
          <MenuItem name="memberPermission" v-if="roles.includes('权限管理')">权限管理</MenuItem>
          <MenuItem name="memberApplication" v-if="roles.includes('会员申请')">会员申请</MenuItem>
        </Submenu>
      </template>
      <template v-if="$route.meta.factory === 'standLib'">
        <!--企业标准库-->
        <Submenu name="qiyeStand" v-if="roles.includes('企业标准库')">
          <template slot="title">
            <i class="yjh-icon iconfont iconqiyebiaozhunku"></i>企业标准库
          </template>
          <MenuItem name="kehuData" v-if="roles.includes('客户主数据库')">客户主数据库</MenuItem>
          <MenuItem name="companyData" v-if="roles.includes('生产企业数据库')">生产企业数据库</MenuItem>
          <MenuItem name="shangyeData" v-if="roles.includes('中国商业数据库')">中国商业数据库</MenuItem>
          <MenuItem name="yiliaoData" v-if="roles.includes('中国医疗机构库')">中国医疗机构库</MenuItem>
          <MenuItem name="yaodianData" v-if="roles.includes('中国药店数据库')">中国药店数据库</MenuItem>
          <MenuItem name="yiyuanData" v-if="roles.includes('中国医院数据库')">中国医院数据库</MenuItem>
          <MenuItem name="zhongduanData" v-if="roles.includes('第三终端数据库')">第三终端数据库</MenuItem>
        </Submenu>
        <!--医药从业人员-->
        <Submenu name="medicienStand" v-if="roles.includes('医药从业人员')">
          <template slot="title">
            <i class="yjh-icon iconfont iconyiyaocongyerenyuan"></i>医药从业人员
          </template>
          <MenuItem name="doctorData" v-if="roles.includes('医生数据库')">医生数据库</MenuItem>
        </Submenu>
        <!--标准库-->
        <Submenu name="goodstand" v-if="roles.includes('产品标准库')">
          <template slot="title">
            <i class="yjh-icon iconfont iconchanpinbiaozhunku1"></i>产品标准库
          </template>
          <MenuItem name="jiyaoData" v-if="roles.includes('中国基药数据库')">中国基药数据库</MenuItem>
          <MenuItem name="guochanData" v-if="roles.includes('国产药品数据库')">国产药品数据库</MenuItem>
          <MenuItem name="jinkouData" v-if="roles.includes('进口药品数据库')">进口药品数据库</MenuItem>
          <MenuItem name="yibaoData" v-if="roles.includes('中国医保数据库')">中国医保数据库</MenuItem>
        </Submenu>
      </template>
    </Menu>
  </div>
</template>

<script>
import bus from '@/components/eventBus.js'
import { getFlowNew } from '@/api/trade'
import { getMenuNum } from '@/api/app'
export default {
  name: 'left-menu',
  data() {
    return {
      openMenu: [], // 打开的一级菜单
      activeName: '', // 激活的菜单
      goodstand: require('@/assets/goodstand.png'),
      invoiceBj: 0, // 北京开票申请数量
      invoiceGy: 0 // 贵阳开票申请数量
    }
  },
  computed: {
    roles() {
      return JSON.stringify(this.$store.state.user.roles.map(item => item.name + item.url))
    },
    vipCount() {
      return this.$store.state.user.vipCount
    }
  },
  mounted() {
    // 北京、贵阳发票右侧切换菜单时刷新数量
    bus.$on('changeMenu', () => {
      this.getInvoiceNum()
    })
    this.getInvoiceNum()
    this.toggleActiveMenu()
    this.initVipCount()
  },
  watch: {
    $route(route) {
      this.toggleActiveMenu()
    },
    roles: {
      handler: function() {
        this.toggleActiveMenu()
      },
      deep: true
    }
  },
  methods: {
    getInvoiceNum() {
      getMenuNum().then(res => {
        if (res.msg === '成功') {
          this.invoiceBj = res.result.beijing_kpsq_sum
          this.invoiceGy = res.result.guiyang_kpsq_sum
        }
      })
    },
    initVipCount() {
      getFlowNew({
        name: 'member_need_check_count',
        data: {}
      }).then(res => {
        let count = (res.result && res.result.count) || 0
        if (Number(count) > 99) {
          count = '...'
        }
        this.$store.commit('SET_VIP_COUNT', count)
      })
    },
    // 激活当前菜单
    toggleActiveMenu() {
      const menu = this.$route.path.split('/')[1] // 一级菜单
      const subMenu = this.$route.meta.menu || this.$route.name // 二级菜单
      this.openMenu = [menu]
      this.activeName = subMenu
      this.$nextTick(() => {
        this.$refs.menu.updateOpened()
        this.$refs.menu.updateActiveName()
      })
    },
    // 菜单展开收起
    openCloseMenu(menu) {
      // 贵阳发票和北京发票药刷新数量接口
      if (menu[0] && (menu[0].includes('Guiyang') || menu[0].includes('Beijing'))) {
        this.getInvoiceNum()
      }
    },
    // 跳转
    jumpMenu(menu) {
      // 贵阳发票和北京发票药刷新数量接口
      if (menu.includes('Gy') || menu.includes('Bj')) {
        this.getInvoiceNum()
      }
      const dataStand = [
        'kehuData', 'companyData', 'shangyeData', 'yiliaoData', 'yaodianData', 'yiyuanData', 'zhongduanData',
        'doctorData',
        'jiyaoData', 'jinkouData', 'guochanData', 'yibaoData'
      ]
      const Bills = [
        'memberBill', 'live', 'meeting', 'diaoyan'
      ]
      if (menu === 'standardLib') {
        this.$router.push({
          name: menu, params: { type: 1 }
        })
      } else if (menu === 'fundCount') {
        this.$router.push({
          name: menu, params: { index: '1' }
        })
      } else if (menu === 'industryVerify' || menu === 'serverVerify') {
        this.$router.push({
          name: menu, params: { type: 1 }
        })
      } else if (dataStand.includes(menu)) {
        this.$router.push({
          name: menu, params: { type: '1' }
        })
      } else if (Bills.includes(menu)) {
        this.$router.push({
          name: menu, params: { type: 'all' }
        })
      } else if (menu.includes('Bj') || menu.includes('Gy')) {
        this.$router.push({
          name: menu, params: { type: '1' }
        })
      } else {
        this.$router.push({ name: menu })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/styles/color.scss";
  .left-menu-content {
    padding: 20px 0;
  }
  .menu-badge {
    position: absolute;
    top: 2px;
    display: inline-block;
    width: 20px;
    text-align: center;
    line-height: 14px;
    height: 14px;
    border-radius: 14px;
    color: #fff;
    background: $red;
  }
</style>
<style lang="scss">
.left-menu-content { // 标准库 产品标准库的箭头
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-submenu-title {
    i.ivu-icon {
      right: 10px;
    }
  }
}
</style>
